// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__honim","title":"Projects_title__iXV9H","projectGrid":"Projects_projectGrid__9RqyD","span":"Projects_span__QqguE"};